// src/components/ui/switch.jsx
"use client"

import * as React from "react"
import * as SwitchPrimitive from "@radix-ui/react-switch"
import PropTypes from "prop-types"

function Switch({
  className,
  style,
  checked,
  defaultChecked,
  disabled,
  onCheckedChange,
  ...props
}) {
  // Derive visual state from controlled (checked) or uncontrolled (defaultChecked)
  const isOn = typeof checked === "boolean" ? checked : !!defaultChecked

  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      disabled={disabled}
      checked={checked}
      defaultChecked={defaultChecked}
      onCheckedChange={onCheckedChange}
      // INLINE STYLES ONLY
      style={{
        display: "inline-flex",
        height: "1.15rem",
        width: "2rem",
        alignItems: "center",
        borderRadius: "9999px",
        border: "1px solid transparent",
        boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
        outline: "none",
        transition: "all 0.2s ease-in-out",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        backgroundColor: isOn ? "var(--primary, #2563eb)" : "var(--input, #e5e7eb)",
        ...style,
      }}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        style={{
          pointerEvents: "none",
          display: "block",
          height: "1rem",
          width: "1rem",
          borderRadius: "50%",
          transition: "transform 0.2s ease-in-out, background-color 0.2s ease-in-out",
          backgroundColor: isOn
            ? "var(--primary-foreground, #ffffff)"
            : "var(--foreground, #111827)",
          transform: isOn ? "translateX(calc(100% - 2px))" : "translateX(0)",
        }}
      />
    </SwitchPrimitive.Root>
  )
}

Switch.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  onCheckedChange: PropTypes.func,
}

export { Switch }
